(function () {
  const GRID_CONTAINER_ID = 'ProductGridContainer';
  const GRID_ID = 'product-grid';
  // Note: Removed the exclusion for price_range so we can target it
  const FILTER_SELECTOR = '.facets-desktop-container .js-filter';
  const INTERVAL = 8;
  const STRIP_CLASS = 'inline-filter-strip';
  
  // Set to true to loop filters indefinitely, false to show each filter only once
  const REPEAT_FILTERS = false; 

  // Helper to map color names to hex codes
  const COLOR_MAP = {
    'Yellow Gold': '#edcd90',
    'Rose Gold': '#f5cbb0',
    'White Gold': '#d5d2d2'
  };

  // SVG for the Karat Diamond
  const DIAMOND_SVG = `
<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.50939 2.50001C9.45754 2.49954 9.4064 2.51196 9.36055 2.53618C9.31471 2.56039 9.27561 2.59564 9.24678 2.63873C9.21795 2.68182 9.2003 2.7314 9.19541 2.78302C9.19051 2.83463 9.19854 2.88665 9.21876 2.93439L9.39845 3.35861L12.5781 10.7727C12.5997 10.8231 12.6342 10.8669 12.6782 10.8998C12.7221 10.9327 12.7739 10.9534 12.8284 10.9599C12.8829 10.9664 12.9381 10.9584 12.9885 10.9368C13.0389 10.9152 13.0828 10.8807 13.1156 10.8367L18.9844 3.00001C19.0192 2.95359 19.0404 2.89838 19.0456 2.84058C19.0508 2.78278 19.0399 2.72467 19.0139 2.67276C18.9879 2.62085 18.948 2.5772 18.8987 2.54668C18.8493 2.51617 18.7924 2.50001 18.7344 2.50001H9.50939ZM32.807 4.53595L29.582 12.0649C29.5618 12.1124 29.5536 12.1642 29.5582 12.2157C29.5629 12.2671 29.5802 12.3167 29.6087 12.3598C29.6372 12.4029 29.676 12.4383 29.7215 12.4627C29.767 12.4872 29.8179 12.5 29.8695 12.5H37.7602C37.8159 12.5 37.8706 12.4852 37.9186 12.4569C37.9667 12.4287 38.0063 12.3882 38.0334 12.3395C38.0605 12.2908 38.0741 12.2357 38.0727 12.18C38.0714 12.1243 38.0552 12.07 38.0258 12.0227L33.3594 4.49454C33.3292 4.44608 33.2864 4.40679 33.2355 4.38096C33.1846 4.35512 33.1276 4.34371 33.0707 4.34798C33.0138 4.35225 32.9591 4.37202 32.9126 4.40516C32.8661 4.4383 32.8296 4.48353 32.807 4.53595ZM6.64064 4.49767L1.97579 12.0227C1.9464 12.07 1.9302 12.1243 1.92887 12.18C1.92754 12.2357 1.94112 12.2908 1.96821 12.3395C1.9953 12.3882 2.03492 12.4287 2.08296 12.4569C2.13099 12.4852 2.1857 12.5 2.24142 12.5H10.132C10.1838 12.5 10.2346 12.4871 10.2801 12.4625C10.3257 12.4379 10.3643 12.4024 10.3928 12.3592C10.4212 12.316 10.4384 12.2664 10.443 12.2149C10.4475 12.1634 10.4392 12.1116 10.4188 12.0641L7.18751 4.53908C7.1644 4.48796 7.12796 4.44401 7.08201 4.41183C7.03606 4.37965 6.98229 4.36044 6.92635 4.3562C6.87042 4.35197 6.81437 4.36287 6.7641 4.38776C6.71382 4.41265 6.67118 4.45062 6.64064 4.49767ZM30.7242 2.50001H20.9235C20.8952 2.49983 20.8674 2.50756 20.8433 2.52234C20.8192 2.53711 20.7997 2.55834 20.787 2.58362C20.7743 2.6089 20.769 2.63722 20.7715 2.66538C20.7741 2.69354 20.7845 2.72042 20.8016 2.74298L27.0453 11.0602C27.0613 11.0815 27.0826 11.0983 27.107 11.1088C27.1315 11.1193 27.1584 11.1232 27.1848 11.12C27.2113 11.1169 27.2365 11.1068 27.2578 11.0908C27.2791 11.0748 27.2958 11.0534 27.3063 11.0289L30.5938 3.35939L30.8594 2.70783C30.8687 2.68546 30.8725 2.66116 30.8705 2.63701C30.8684 2.61285 30.8605 2.58956 30.8474 2.56913C30.8344 2.5487 30.8165 2.53174 30.7955 2.51971C30.7745 2.50767 30.7508 2.50091 30.7266 2.50001H30.7242ZM18.6719 35L11.6852 15.1961C11.6647 15.1386 11.6268 15.0889 11.5769 15.0537C11.5269 15.0186 11.4673 14.9999 11.4063 15H2.00782C1.95338 14.9999 1.89999 15.015 1.85373 15.0437C1.80747 15.0724 1.77021 15.1135 1.74619 15.1624C1.72217 15.2113 1.71235 15.2659 1.71786 15.3201C1.72337 15.3742 1.74399 15.4257 1.77736 15.4688L18.6524 37.3289C18.7095 37.4029 18.791 37.4542 18.8824 37.4738C18.9738 37.4934 19.0691 37.48 19.1516 37.436C19.2345 37.3923 19.299 37.3204 19.3332 37.2332C19.3675 37.146 19.3693 37.0494 19.3383 36.961L18.6719 35ZM37.9922 15H28.5938C28.533 15 28.4738 15.0189 28.4242 15.054C28.3747 15.0891 28.3373 15.1388 28.3172 15.1961L20.6453 36.9274C20.6131 37.0186 20.6144 37.1183 20.6491 37.2087C20.6837 37.299 20.7494 37.374 20.8344 37.4203C20.9194 37.4664 21.0179 37.4807 21.1125 37.4608C21.2071 37.4409 21.2915 37.3881 21.3508 37.3117L38.2227 15.4688C38.256 15.4257 38.2767 15.3742 38.2822 15.3201C38.2877 15.2659 38.2779 15.2113 38.2538 15.1624C38.2298 15.1135 38.1926 15.0724 38.1463 15.0437C38.1 15.015 38.0466 14.9999 37.9922 15ZM20.25 6.16642L24.625 12C24.6598 12.0464 24.681 12.1016 24.6862 12.1594C24.6915 12.2172 24.6805 12.2754 24.6545 12.3273C24.6286 12.3792 24.5887 12.4228 24.5393 12.4533C24.4899 12.4839 24.433 12.5 24.375 12.5H15.625C15.567 12.5 15.5101 12.4839 15.4607 12.4533C15.4114 12.4228 15.3715 12.3792 15.3455 12.3273C15.3195 12.2754 15.3086 12.2172 15.3138 12.1594C15.319 12.1016 15.3402 12.0464 15.375 12L19.75 6.16642C19.7791 6.12761 19.8169 6.09611 19.8603 6.07441C19.9037 6.05271 19.9515 6.04142 20 6.04142C20.0485 6.04142 20.0964 6.05271 20.1398 6.07441C20.1832 6.09611 20.2209 6.12761 20.25 6.16642ZM19.7031 30.4094L14.4141 15.4164C14.3975 15.3693 14.3924 15.3189 14.3993 15.2694C14.4062 15.2199 14.4248 15.1728 14.4537 15.1321C14.4825 15.0913 14.5207 15.058 14.5651 15.035C14.6094 15.012 14.6587 15 14.7086 15H25.2914C25.3414 15 25.3906 15.012 25.435 15.035C25.4793 15.058 25.5175 15.0913 25.5464 15.1321C25.5752 15.1728 25.5939 15.2199 25.6007 15.2694C25.6076 15.3189 25.6026 15.3693 25.586 15.4164L20.2945 30.4094C20.273 30.4702 20.2331 30.5229 20.1803 30.5602C20.1276 30.5974 20.0646 30.6174 20 30.6174C19.9354 30.6174 19.8724 30.5974 19.8197 30.5602C19.767 30.5229 19.7271 30.4702 19.7055 30.4094H19.7031Z" fill="#1A5963"/>
</svg>
`;

  // Configuration for Custom Price Ranges
  const PRICE_RANGES = [
    { top: 'Below', bottom: '₹30k', min: '', max: '30000' },
    { top: 'Between', bottom: '₹ 30K - ₹ 60K', min: '30000', max: '60000' },
    { top: 'Between', bottom: '₹ 60K - ₹ 90K', min: '60000', max: '90000' },
    { top: 'Between', bottom: '₹ 90K - ₹ 130k', min: '90000', max: '130000' },
    { top: 'Between', bottom: '₹ 130k - ₹ 250k', min: '130000', max: '250000' }
  ];

  function getFilters() {
    return Array.from(document.querySelectorAll(FILTER_SELECTOR));
  }

  function triggerNativeUpdate(element) {
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
    // If the theme form listens to submit
    const form = element.closest('form');
    if (form) form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function buildStripFor(filter) {
    const titleEl = filter.querySelector('.thb-filter-title');
    if (!titleEl) return null;
    const originalTitle = (titleEl.childNodes[0] && titleEl.childNodes[0].nodeValue || titleEl.textContent || '').trim();
    
    const strip = document.createElement('div');
    strip.className = STRIP_CLASS;
    
    const titleHeader = document.createElement('h3');
    titleHeader.className = `${STRIP_CLASS}__title`;
    
    const optionsWrapper = document.createElement('div');
    optionsWrapper.className = `${STRIP_CLASS}__options`;
    
    strip.appendChild(titleHeader);
    strip.appendChild(optionsWrapper);

    // --- LOGIC 1: PRICE FILTER ---
    if (originalTitle.toLowerCase().includes('price')) {
      titleHeader.textContent = 'Shop By Price';
      strip.classList.add('type-price');
      
      const minInput = filter.querySelector('.field__input_min');
      const maxInput = filter.querySelector('.field__input_max');
      if (!minInput || !maxInput) return null;

      // Parse the current values as floats to ignore Shopify's '.00' formatting.
      // If empty, default to 0.
      const currentMin = parseFloat(minInput.value) || 0;
      const currentMax = parseFloat(maxInput.value) || 0;

      PRICE_RANGES.forEach(range => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = `${STRIP_CLASS}__btn`;
        
        // Parse the range values as floats for accurate comparison
        const rMin = parseFloat(range.min) || 0;
        const rMax = parseFloat(range.max) || 0;

        // Check if currently active using numeric comparison
        if (rMin === currentMin && rMax === currentMax) {
            btn.classList.add('is-active');
        }

        btn.innerHTML = `
          <span class="filter-text-top">${range.top}</span>
          <span class="filter-text-bottom">${range.bottom}</span>
        `;

        btn.addEventListener('click', (e) => {
          e.preventDefault();
          minInput.value = range.min;
          maxInput.value = range.max;
          triggerNativeUpdate(maxInput);
        });

        optionsWrapper.appendChild(btn);
      });
      return strip;
    }

    // --- LOGIC 2: REGULAR CHECKBOX FILTERS (Metal Color & Karats) ---
    const inputs = filter.querySelectorAll('input[type="checkbox"]');
    if (!inputs.length) return null;

    let isMetal = originalTitle.toLowerCase().includes('color') || originalTitle.toLowerCase().includes('metal');
    let isKarat = originalTitle.toLowerCase().includes('karat');

    if (isMetal) {
        titleHeader.textContent = 'Three Shades of Gold, One You';
        strip.classList.add('type-color');
    } else if (isKarat) {
        titleHeader.textContent = 'Select The Karats';
        strip.classList.add('type-icon');
    } else {
        // Fallback for other filters
        titleHeader.textContent = originalTitle;
        strip.classList.add('type-color');
    }

    inputs.forEach((input) => {
      const lbl = filter.querySelector(`label[for="${input.id}"]`);
      if (!lbl) return;
      const nameEl = lbl.querySelector('.filter-name');
      const text = (nameEl ? nameEl.textContent : lbl.textContent || '').trim();
      if (!text || text === '-') return;

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = `${STRIP_CLASS}__btn`;
      if (input.checked) btn.classList.add('is-active');

      let innerVisual = '';
      if (isMetal) {
          const mappedColor = COLOR_MAP[text] || '#ccc';
          innerVisual = `<span class="swatch-inner-color" style="background-color: ${mappedColor};"></span>`;
      } else if (isKarat) {
          innerVisual = DIAMOND_SVG;
      } else {
          // Fallback simple circle
          innerVisual = `<span class="swatch-inner-color" style="background-color: #eee;"></span>`;
      }

      btn.innerHTML = `
        <div class="swatch-circle">
            ${innerVisual}
        </div>
        <span class="swatch-label">${text}</span>
      `;

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById(input.id);
        if (target) {
            target.click();
            triggerNativeUpdate(target);
        }
      });

      optionsWrapper.appendChild(btn);
    });

    return strip;
  }

  function getProductCards(grid) {
    return Array.from(grid.children).filter((el) => {
      return !(el.classList && el.classList.contains(STRIP_CLASS));
    });
  }

  function clearStrips(grid) {
    grid.querySelectorAll(`:scope > .${STRIP_CLASS}`).forEach((s) => s.remove());
  }

  function injectStrips() {
    const grid = document.getElementById(GRID_ID);
    if (!grid) return;

    clearStrips(grid);

    const filters = getFilters();
    if (!filters.length) return;

    const cards = getProductCards(grid);
    if (!cards.length) return;

    let filterIndex = 0;
    let slotCount = 0;
    let targetSlot = INTERVAL;

    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];

      if (card.classList && card.classList.contains('promotion-column')) {
        slotCount += 2;
      } else {
        slotCount += 1;
      }

      if (slotCount >= targetSlot) {
        // Break out of the loop if REPEAT_FILTERS is false and we've shown all filters
        if (!REPEAT_FILTERS && filterIndex >= filters.length) {
          break;
        }

        const filter = filters[filterIndex % filters.length];
        const strip = buildStripFor(filter);
        filterIndex++;

        if (strip) {
          card.parentNode.insertBefore(strip, card.nextSibling);
        }

        targetSlot += INTERVAL;
      }
    }
  }

  let scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      injectStrips();
    });
  }

  function watchContainer() {
    const container = document.getElementById(GRID_CONTAINER_ID);
    if (!container) return;

    const observer = new MutationObserver((mutations) => {
      const meaningful = mutations.some((m) => {
        const added = Array.from(m.addedNodes).some((n) => n.nodeType === 1 && !(n.classList && n.classList.contains(STRIP_CLASS)));
        const removed = Array.from(m.removedNodes).some((n) => n.nodeType === 1 && !(n.classList && n.classList.contains(STRIP_CLASS)));
        return added || removed;
      });
      if (meaningful) schedule();
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    injectStrips();
    watchContainer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();